"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ContactFormDialog } from "@/components/contact-form-dialog";

export function TalkToSalesButton({
  variant = "default",
  size = "default",
  className,
}: {
  variant?: "default" | "outline";
  size?: "default" | "lg" | "sm";
  className?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={() => setOpen(true)}
      >
        Talk to Sales
      </Button>
      <ContactFormDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
